import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import BatteryFullIcon from "@mui/icons-material/BatteryFull";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import { useNavigate } from "react-router-dom";
import {
    ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';

const decodeStress = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{
            background: "#f3f4f6",
            minHeight: {
                xs: 'calc(100vh - 56px)',
                sm: 'calc(100vh - 64px)',
                md: 'calc(100vh - 70px)',
            },
        }}>
            <Box
                sx={{
                    // py: 4,
                    background: "#f3f4f6",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    px: 2,
                    position: "relative"
                }}
            >
                <Box display="flex" justifyContent="space-between" gap={1} mb={2} width="100%">
                    <Box sx={{ mt: 2, }}>
                        <Typography variant="h6" sx={{
                            fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            fontSize: { xs: '1.1rem', sm: '1.25rem' },
                        }}>
                            Wellness Assessment
                        </Typography>
                    </Box>

                    <IconButton
                        onClick={() => navigate("/echo-sounds")}
                        sx={{
                            backgroundColor: '#F0F5FF',
                            width: { xs: 32, sm: 35 },
                            height: { xs: 32, sm: 35 },
                            mt: 2,
                            borderRadius: '50%',
                            color: '#0B2D6B',
                            position: "absolute",
                            top: 0,
                            right: { xs: 5, sm: 10 },
                            '&:hover': {
                                backgroundColor: '#E0EBFF'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                </Box>
                {/* Card */}
                <Box
                    sx={{
                        width: {
                            xs: '100%',
                            sm: '90%',
                            md: 420,
                        },
                        maxWidth: 420,
                        bgcolor: "#f8fcffd9",
                        borderRadius: "24px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        overflow: "hidden",
                        position: "relative",
                    }}
                >
                    {/* Close Button */}
                    {/* <IconButton
                    onClick={() => navigate("/echo-sounds")}
                    sx={{ position: "absolute", top: 10, right: 12 }}
                >
                    <CloseIcon />
                </IconButton> */}

                    {/* Top Icon Badge */}
                    {/* <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "20px",
            background: "linear-gradient(135deg, #00C6FF, #7E57C2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: -32,
            left: "50%",
            transform: "translateX(-50%)",
            boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
          }}
        >
          ❤️
        </Box> */}

                    {/* Header */}
                    <Box sx={{ pt: { xs: 3, sm: 4 }, px: { xs: 2, sm: 3 }, textAlign: "center" }}>
                        <Box display="flex" justifyContent="center" gap={3} mb={3}>
                            <SelfImprovementIcon sx={{ color: "#FFA726" }} />
                            <BatteryFullIcon sx={{ color: "#66BB6A" }} />
                            <MusicNoteIcon sx={{ color: "#7E57C2" }} />
                        </Box>

                        <Typography variant="h6" sx={{
                            fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            fontSize: { xs: '1.1rem', sm: '1.25rem' },
                        }}>
                            Decode Your Stress.
                            <br />
                            Let Echo Sounds Reset You.
                        </Typography>

                        <Typography
                            color="text.secondary"
                            sx={{ mt: 1, fontSize: { xs: 12, sm: 13 }, lineHeight: 1.6, color: "#6b7280" }}
                        >
                            Map where your body holds work-day tension, check your energy reserves, and get frequency-matched therapeutic sounds to reset and recharge.
                        </Typography>
                    </Box>

                    {/* Divider Section */}
                    <Box sx={{ mt: 2, borderTop: "1px solid #eee" }} />

                    {/* Features */}
                    <Box sx={{ px: { xs: 2, sm: 3 }, py: 3, fontSize: 8 }}>
                        <Feature
                            icon="👉"
                            title="Body Scan"
                            text="tap where you feel tension on an interactive body map"
                        />
                        <Feature
                            icon="🔋"
                            title="Energy Battery"
                            text="set your mental energy level and identify what's draining you"
                        />
                        <Feature
                            icon="🎵"
                            title="Sound Therapy Rx"
                            text="get frequency-matched tracks based on your combined profile"
                        />
                    </Box>


                </Box>
                <Button
                    onClick={() => navigate("/assessment-flow")}
                    sx={{
                        mt: 2,
                        width: {
                            xs: '100%',
                            sm: '90%',
                            md: 420,
                        },
                        maxWidth: 420,
                        py: 1.6,
                        borderRadius: "14px",
                        fontWeight: "bold",
                        color: "#fff",
                        fontSize: 14,
                        background: "linear-gradient(90deg, #26A69A, #7E57C2)",
                        "&:hover": {
                            background: "linear-gradient(90deg, #1e8e88, #6a45c2)",
                        },
                    }}
                >
                    Begin Assessment
                </Button>
            </Box>
        </Box>

    );
};

const Feature = ({ icon, title, text }) => (
    <Box display="flex" gap={2} mb={2.5}>
        <Box
            sx={{
                width: 44,
                height: 44,
                borderRadius: "12px",
                background: "#f1f5f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
            }}
        >
            {icon}
        </Box>

        <Typography sx={{ fontSize: { xs: 13, sm: 14 } }}>
            <strong>{title}</strong> — {text}
        </Typography>
    </Box>
);

export default decodeStress;